<template>
  <div id="later-overlay" class="modal in" style="display: block">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header clearfix">
          <button class="exit-popup" aria-label="Exit this popup" @click="handleClose()">
            <i class="fas fa-times"></i>
          </button>
        </div>
        <div class="modal-body">
          <div class="modal-body-content clearfix">
            <table id="later-table">
              <tbody>
                <tr>
                  <td>
                    <h3 tabindex="0">
                      <span>Schedule delivery for</span>
                      {{ restName }}
                    </h3>
                    <br />
                    <p tabindex="0">
                      Please schedule a later time for your delivery. The hours listed here are the
                      <i>regular</i> hours for {{ restName }}. Please schedule a time at least 60 minutes after they open.
                    </p>
                  </td>
                </tr>
                <tr class="later-bottom">
                  <td>
                    <table class="later-hours">
                      <tbody>
                        <tr>
                          <td>
                            <span class="later-title"><b>Hours</b></span>
                          </td>
                        </tr>
                        <tr>
                          <td><br /></td>
                        </tr>

                        <tr v-for="(day, key) in hoursSorted" :key="key" class="new-hours-row">
                          <td tabindex="0" class="day">
                            <span>{{ key }}:</span>
                          </td>
                          <table>
                            <tbody>
                              <tr class="new-hours">
                                <td tabindex="0" v-for="(setOfHours, i) in day" :key="i">
                                  {{ formatHours(setOfHours.openTime, setOfHours.closeTime) }}
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </tr>
                      </tbody>
                    </table>
                    <table>
                      <tbody>
                        <tr>
                          <td colspan="2" bgcolor="FFFFFF"></td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                  <td>
                    <div id="laterForm">
                      <span tabindex="0" class="later-title">Pick a Time</span><br />
                      <br />
                      <table>
                        <tbody>
                          <tr>
                            <td class="later-times">
                              <datepicker
                                class="later-order-datepicker"
                                id="later-datepicker"
                                :input-class="'later-order-datepicker-input form-input'"
                                :format="'MM/dd/yyyy'"
                                v-model="laterDate"
                                :disabled-dates="disabledDates"
                                @input="updateSelectedDay"
                                :typeable="true"
                                aria-label="Enter Date"
                              ></datepicker>
                              <span class="time-wrapper"
                                ><select class="form-input time" autocomplete="off" v-model="laterHour" aria-label="Select Hour">
                                  <option value="">hour</option>
                                  <option v-for="(hour, i) in enabledHours" :key="i" :value="hour.hourValue">
                                    {{ hour.hour }}
                                    {{ hour.timePeriod }}
                                  </option>
                                </select>
                              </span>
                              <span class="time-wrapper">
                                <select class="form-input time" autocomplete="off" v-model="laterMinute" aria-label="Select Minute">
                                  <option value="00">00</option>
                                  <option value="15">15</option>
                                  <option value="30">30</option>
                                  <option value="45">45</option>
                                </select>
                              </span>
                            </td>
                          </tr>
                          <tr>
                            <td colspan="2">
                              <br /><input
                                type="button"
                                class="blue-background-button"
                                id="setButton"
                                value="Set Delivery Date/Time"
                                @click="submitCheckTime"
                              /><br />
                              <span class="modal-loading" v-if="showSpinner">
                                <i class="fas fa-spinner fa-spin fa-2x"></i>
                                ...Loading </span
                              ><br />
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Datepicker from 'vuejs-datepicker'
const debounce = require('lodash/debounce')

import { mapActions } from 'vuex'
export default {
  components: {
    Datepicker,
  },
  props: {
    hours: { type: Object, required: true },
    restName: { type: String, required: true },
    restId: { type: [String, Number], required: true },
  },
  data: function () {
    var today = new Date()
    return {
      laterDate: today,
      laterHour: '',
      laterMinute: '00',
      minDate: new Date(today.getFullYear(), today.getMonth(), today.getDate()),
      selectedDay: today.getDay(),
      showSpinner: false,
    }
  },
  computed: {
    hoursSorted: function () {
      var sortedHours = {
        Monday: this.hours.monday,
        Tuesday: this.hours.tuesday,
        Wednesday: this.hours.wednesday,
        Thursday: this.hours.thursday,
        Friday: this.hours.friday,
        Saturday: this.hours.saturday,
        Sunday: this.hours.sunday,
      }
      return sortedHours
    },
    enabledHours: function () {
      var enabledHours = []
      switch (this.selectedDay) {
        case 1:
          this.hours.monday.forEach((setOfHours) => {
            var openHour = setOfHours.openTime.split(':')
            var closedHour = setOfHours.closeTime.split(':')
            var acceptableHours = this.getEnabledHours(openHour, closedHour)
            acceptableHours.forEach((hourInfo) => {
              const found = enabledHours.some((distinctHourInfo) => distinctHourInfo.hourAndTimePeriod === hourInfo.hourAndTimePeriod)
              if (!found) {
                enabledHours.push(hourInfo)
              }
            })
          })

          break
        case 2:
          this.hours.tuesday.forEach((setOfHours) => {
            var openHour = setOfHours.openTime.split(':')
            var closedHour = setOfHours.closeTime.split(':')
            var acceptableHours = this.getEnabledHours(openHour, closedHour)
            acceptableHours.forEach((hourInfo) => {
              const found = enabledHours.some((distinctHourInfo) => distinctHourInfo.hourAndTimePeriod === hourInfo.hourAndTimePeriod)
              if (!found) {
                enabledHours.push(hourInfo)
              }
            })
          })

          break
        case 3:
          this.hours.wednesday.forEach((setOfHours) => {
            var openHour = setOfHours.openTime.split(':')
            var closedHour = setOfHours.closeTime.split(':')
            var acceptableHours = this.getEnabledHours(openHour, closedHour)
            acceptableHours.forEach((hourInfo) => {
              const found = enabledHours.some((distinctHourInfo) => distinctHourInfo.hourAndTimePeriod === hourInfo.hourAndTimePeriod)
              if (!found) {
                enabledHours.push(hourInfo)
              }
            })
          })

          break
        case 4:
          this.hours.thursday.forEach((setOfHours) => {
            var openHour = setOfHours.openTime.split(':')
            var closedHour = setOfHours.closeTime.split(':')
            var acceptableHours = this.getEnabledHours(openHour, closedHour)
            acceptableHours.forEach((hourInfo) => {
              const found = enabledHours.some((distinctHourInfo) => distinctHourInfo.hourAndTimePeriod === hourInfo.hourAndTimePeriod)
              if (!found) {
                enabledHours.push(hourInfo)
              }
            })
          })

          break
        case 5:
          this.hours.friday.forEach((setOfHours) => {
            var openHour = setOfHours.openTime.split(':')
            var closedHour = setOfHours.closeTime.split(':')
            var acceptableHours = this.getEnabledHours(openHour, closedHour)
            acceptableHours.forEach((hourInfo) => {
              const found = enabledHours.some((distinctHourInfo) => distinctHourInfo.hourAndTimePeriod === hourInfo.hourAndTimePeriod)
              if (!found) {
                enabledHours.push(hourInfo)
              }
            })
          })

          break
        case 6:
          this.hours.saturday.forEach((setOfHours) => {
            var openHour = setOfHours.openTime.split(':')
            var closedHour = setOfHours.closeTime.split(':')
            var acceptableHours = this.getEnabledHours(openHour, closedHour)
            acceptableHours.forEach((hourInfo) => {
              const found = enabledHours.some((distinctHourInfo) => distinctHourInfo.hourAndTimePeriod === hourInfo.hourAndTimePeriod)
              if (!found) {
                enabledHours.push(hourInfo)
              }
            })
          })

          break
        case 0:
          this.hours.sunday.forEach((setOfHours) => {
            var openHour = setOfHours.openTime.split(':')
            var closedHour = setOfHours.closeTime.split(':')
            var acceptableHours = this.getEnabledHours(openHour, closedHour)
            acceptableHours.forEach((hourInfo) => {
              const found = enabledHours.some((distinctHourInfo) => distinctHourInfo.hourAndTimePeriod === hourInfo.hourAndTimePeriod)
              if (!found) {
                enabledHours.push(hourInfo)
              }
            })
          })

          break
        default:
          return
      }
      return enabledHours
    },
    disabledDates: function () {
      var today = new Date()
      var thirtyDaysFromToday = new Date()
      thirtyDaysFromToday.setDate(thirtyDaysFromToday.getDate() + 30)
      var disabledDays = []
      for (const [key, value] of Object.entries(this.hours)) {
        value.forEach((setOfHours) => {
          if (setOfHours.openTime === 'closed') {
            switch (key) {
              case 'monday':
                disabledDays.push(1)
                break
              case 'tuesday':
                disabledDays.push(2)
                break
              case 'wednesday':
                disabledDays.push(3)
                break
              case 'thursday':
                disabledDays.push(4)
                break
              case 'friday':
                disabledDays.push(5)
                break
              case 'saturday':
                disabledDays.push(6)
                break
              case 'sunday':
                disabledDays.push(0)
                break
              default:
                return
            }
          }
        })
      }
      return {
        to: new Date(today.getFullYear(), today.getMonth(), today.getDate()),
        from: thirtyDaysFromToday,
        days: disabledDays,
      }
    },
    maxDate: function () {
      var today = new Date()
      var twoMonthsFromToday = today.setDate(today.getDate() + 60)
      return twoMonthsFromToday
    },
  },
  methods: {
    ...mapActions({
      checkTime: 'restMenu/checkTime',
      setTime: 'restMenu/setTime',
    }),
    handleClose() {
      this.$emit('hideModal')
    },
    updateSelectedDay() {
      if (this.laterDate) {
        this.selectedDay = this.laterDate.getDay()
        this.$nextTick(function () {
          if (!this.enabledHours.some((distinctHourInfo) => distinctHourInfo.hourValue === this.laterHour)) {
            this.laterHour = ''
            this.laterMinute = '00'
          }
        })
      }
    },
    formatHours(open, closed) {
      if (open === 'closed') {
        return 'closed'
      }
      return open + ' - ' + closed
    },
    getEnabledHours(open, closed) {
      var enabledHours = []
      var today = new Date()
      var hourNow = today.getHours()
      if (open[0] !== 'closed') {
        if (open[1].includes('PM') && Number(open[0]) !== 12) {
          open = Number(open[0]) + 12
        } else {
          open = Number(open[0])
        }
        if (closed[1].includes('PM') && Number(closed[0]) !== 12) {
          closed = Number(closed[0]) + 12
        } else {
          closed = Number(closed[0])
        }
        for (let i = open; i <= closed; i++) {
          var timePeriod = 'AM'
          var hourValue = i
          var hour = i
          if (hour >= 12) {
            timePeriod = 'PM'
            if (hour > 12) {
              hour -= 12
            }
          }
          var hourInfo = {
            hour: hour,
            hourValue: hourValue,
            timePeriod: timePeriod,
            hourAndTimePeriod: `${hour}${timePeriod}`,
          }
          if (this.laterDate.getDate() === today.getDate() && hourValue > hourNow) {
            enabledHours.push(hourInfo)
          } else if (this.laterDate.getDate() !== today.getDate()) {
            enabledHours.push(hourInfo)
          }
        }
      }
      return enabledHours
    },
    submitCheckTime: debounce(
      async function () {
        this.showSpinner = true
        var errors = []
        if (!this.laterDate) {
          errors.push('Please select the date you would like your order to be delvered on.')
        }
        if (!this.laterHour) {
          errors.push('Please select the hour you would like your order to be delivered at.')
        }
        if (!this.laterMinute) {
          errors.push('Please select the minute you would like your order to be delivered at.')
        }
        if (errors.length > 0) {
          var errorMsg = ''
          for (var eachError in errors) {
            errorMsg += '\n' + errors[eachError] + '\n'
          }
          alert(errorMsg)
          this.showSpinner = false
          return false
        }
        var year = this.laterDate.getFullYear()
        var month = this.laterDate.getMonth() + 1
        var day = this.laterDate.getDate()
        if (month < 10) {
          month = '0' + month
        }
        if (day < 10) {
          day = '0' + day
        }
        var duedate = year + '' + month + '' + day
        var result = await this.checkTime({
          duedate: duedate,
          dueHour: this.laterHour,
          dueMin: this.laterMinute,
          restId: this.restId,
        })
        if (result) {
          await this.setTime({
            duedate: duedate,
            dueHour: this.laterHour,
            dueMin: this.laterMinute,
          })
          this.showSpinner = false
          this.$emit('goToMenu')
        } else {
          this.showSpinner = false
          return false
        }
      },
      1000,
      { leading: true, trailing: false }
    ),
  },
}
</script>
<style scoped>
.new-hours-row {
  border-bottom: dotted 0.5px;
}
.new-hours {
  display: grid !important;
  text-align: right;
}
.modal-dialog {
  color: black;
  border-radius: 20px;
  max-height: calc(100vh - 25%);
  overflow: auto;
}
.modal-body {
  min-height: 600px;
}
@media only screen and (max-width: 767px) {
  .fa-times {
    color: #333 !important;
  }
  .modal-dialog {
    max-height: calc(100vh - 5%);
  }
}
</style>
